export default {
  jp: {
    error: {
      companyId: {
        notExist: '会社は存在しないか削除されています。最新の情報を確認してください。'
      },
      branchId: {
        notExist: '支社・支局／媒体は存在しないか削除されています。最新の情報を確認してください。',
        undeletable: '関連するデータが存在するため削除できません。'
      },
      branchName: {
        required: '支社・支局／媒体名は入力必須項目です。',
        maxLength: '支社・支局／媒体名は100文字以内で入力してください。',
        existInCompany: '同じ支社・支局／媒体名が既に存在します。'
      },
      branchNameKana: {
        required: '支社・支局／媒体名カナは入力必須項目です。',
        maxLength: '支社・支局／媒体名カナは100文字以内で入力してください。',
        invalid: '支社・支局／媒体名カナは全角カナ、・、－で入力してください。'
      }
    }
  },
  en: {
  }
}
